export const environment = {
  production: false,
  config: {
    api: 'https://api.takeoffprojects.com/apiservice/',
    // api: "http://localhost/takeoff_projects_website/takeoffprojects_api/",
    // api:
    //   'http://192.168.1.186/GitHub/takeoff_projects_website/takeoffprojects_api/',
    // newApi: 'http://192.168.1.186:8080/',
    // api: 'https://api.takeoffprojects.com/apiservice/',
    // newApi: 'https://new-api.takeoffprojects.com/',
    // newApi: 'http://192.168.1.38:8080/',
    // api: 'http://192.168.1.186/takeoff/takeoff_admin/',
     newApi: 'https://new-api.takeoffprojects.com/',
    server_api: 'projectsa',
    // server_api: 'apiservice',
    paypal_clientId:
      'AbuUC6nwZoFvDcyxuidhvR-gjXMG7SujAbVlIMu9WQlMwfHL8gO5H1NdIXzj_LIIc2fCUCgUufASTsMA',
    app_url: 'https://takeoffprojects.com',
    blockInspect: false,
    advertisment_api: 'https://takeoffadvertisement.ymtsindia.net/api/',
    env: 'Test',
    port: 4000
  }
};
